export const GET_EKG_RECORDING = 'ekgRecording/GET_EKG_RECORDING';
export const GET_EKG_QT = 'ekgRecording/GET_EKG_QT';
export const POST_QT_REQUEST = 'ekgRecording/POST_QT_REQUEST';
export const UPDATE_QT_STATUS = 'ekgRecording/UPDATE_QT_STATUS';
export const POST_QT_VALUES = 'ekgRecording/POST_QT_VALUES';



// WEBPACK FOOTER //
// ./src/state/reducers/ekgRecordings/types.js